const body = document.body;
const pageKey = body.dataset.page || "home";
const headerMount = document.querySelector("[data-site-header]");
const footerMount = document.querySelector("[data-site-footer]");
const root = headerMount?.dataset.root || footerMount?.dataset.root || "./";
const shopifyBridge = window.ROADROAM_SHOPIFY || null;
const assets = shopifyBridge?.assetBase || `${root}../assets/`;
const assetUrl = (path) => shopifyBridge
  ? `${assets}rr-${String(path).replaceAll("/", "--")}`
  : `${assets.replace(/\/$/, "")}/${path}`;
const pageHref = (href) => {
  if (/^(?:https?:)?\/\/|^(?:#|mailto:|tel:|\/)/.test(href)) return href;
  if (!shopifyBridge) return `${root}${href}`;
  const match = String(href).match(/^([^?#]*)([?#].*)?$/);
  const path = match?.[1] || href;
  const suffix = match?.[2] || "";
  return `${shopifyBridge.routes[path] || path}${suffix}`;
};
const siteConfig = Object.freeze({
  locale: "en-US",
  canonicalBase: "https://roadroam.com/",
  contactEmail: "support@roadroam.com",
  social: Object.freeze({
    facebook: "https://www.facebook.com/share/18pjY55RiS/?mibextid=wwXIfr",
    instagram: "https://www.instagram.com/roadroam_official/",
    youtube: "https://www.youtube.com/@RoadRoam-RV",
    tiktok: "https://www.tiktok.com/@roadroam",
    x: "https://x.com/roadroamrv",
  }),
  commerce: Object.freeze({
    provider: "shopify",
    phase: "prelaunch",
    storefrontMcpEndpoint: "",
  }),
  assistant: Object.freeze({
    enabled: true,
    mode: "curated-site-knowledge",
    endpoint: "",
    plannedProvider: "shopify-inbox",
  }),
});
window.ROADROAM_CONFIG = siteConfig;
body.dataset.commerceProvider = siteConfig.commerce.provider;
const campaign = {
  phase: "prelaunch",
  platform: "Kickstarter",
  destination: "launch/index.html",
  primaryLabel: "Follow on Kickstarter",
  status: "Planned Kickstarter campaign",
  note: "Independent pre-launch",
};
body.dataset.campaignPhase = campaign.phase;
const campaignHref = /^(?:https?:)?\/\//.test(campaign.destination) ? campaign.destination : pageHref(campaign.destination);
const commerceProducts = window.ROADROAM_SHOPIFY?.products || [
  { title: "RV Surge Protector 30 amp", url: "/products/rv-surge-protector-30-amp" },
  { title: "RV Surge Protector 50 amp", url: "/products/rv-surge-protector-50-amp" },
];
const commerceCollectionUrl = window.ROADROAM_SHOPIFY?.collectionUrl || "/collections/all";
const commerceCartUrl = window.ROADROAM_SHOPIFY?.cartUrl || "/cart";
const commerceCartCount = Number(window.ROADROAM_SHOPIFY?.cartCount || 0);
const renderCommerceCartCount = (rawCount) => {
  const parsedCount = Number(rawCount);
  if (!Number.isFinite(parsedCount)) return;
  const count = Math.max(0, Math.trunc(parsedCount));
  const itemLabel = count === 1 ? "item" : "items";

  document.querySelectorAll(".header-cart").forEach((link) => {
    link.setAttribute("aria-label", `Cart with ${count} ${itemLabel}`);
    const badge = link.querySelector("b");
    if (badge) badge.textContent = String(count);
  });
  document.querySelectorAll(".mobile-cart").forEach((link) => {
    link.setAttribute("aria-label", `Cart with ${count} ${itemLabel}`);
    const badge = link.querySelector("b");
    if (badge) badge.textContent = String(count);
  });
};
const navSections = [
  { key: "launch", label: "RV Leveling Launch", href: "launch/index.html" },
  {
    key: "about",
    label: "About",
    href: "about/index.html",
    activeKeys: ["about", "contact", "brand", "business", "our-story", "system", "road-stories", "blog"],
    note: "Company",
    title: "Built for life on the road.",
    image: "images/rv-campsite-lake-powell.webp",
    imageWidth: 2200,
    imageHeight: 1467,
    imageAlt: "RV and tow vehicle at a lakeside campsite",
    imageLabel: "Inside ROADROAM",
    children: [
      ["Story", "about/index.html"],
      ["Connect", "about/connect/index.html"],
    ],
  },
  {
    key: "support",
    label: "Support",
    href: "support/index.html",
    activeKeys: ["support", "service", "technical", "downloads", "shipping", "returns", "privacy", "terms", "warranty", "faq"],
    note: "Help center",
    title: "Find the right answer.",
    image: "images/ecosystem/smart-sensing.webp",
    imageWidth: 1600,
    imageHeight: 2400,
    imageAlt: "RV dashboard controls in a real cab",
    imageLabel: "Start with support",
    groups: [
      {
        label: "Orders & coverage",
        items: [
          ["Shipping policy", "support/shipping/index.html"],
          ["Refund policy", "support/returns/index.html"],
          ["Privacy policy", "support/privacy/index.html"],
          ["Terms of service", "support/terms/index.html"],
        ],
      },
    ],
  },
];

const isSectionCurrent = (section) =>
  section.key === pageKey || (section.activeKeys || []).includes(pageKey);

const desktopNavItems = navSections
  .map((section) => {
    const current = isSectionCurrent(section);
    const currentState = current ? ' is-current' : '';
    const currentAria = current ? ' aria-current="page"' : '';
    if (!section.children && !section.groups) {
      return `<a class="nav-link${currentState}" href="${pageHref(section.href)}"${currentAria}>${section.label}</a>`;
    }

    const links = section.groups
      ? section.groups
          .flatMap((group) => group.items)
          .map(([label, href]) => `<a href="${pageHref(href)}"><span>${label}</span></a>`)
          .join("")
      : section.children
          .map(([label, href]) => `<a href="${pageHref(href)}"><span>${label}</span></a>`)
          .join("");
    return `<div class="nav-item nav-item--${section.key} has-menu">
      <a class="nav-link${currentState}" href="${pageHref(section.href)}"${currentAria}>${section.label}<i aria-hidden="true">⌄</i></a>
      <div class="nav-panel">
        <div class="nav-panel-links${section.groups ? " nav-panel-links--grouped" : ""}">${links}</div>
      </div>
    </div>`;
  });

const desktopNavLeft = desktopNavItems.slice(0, 2).join("");
const desktopNavRight = desktopNavItems.slice(2).join("");

const mobileNav = navSections
  .map((section) => {
    if (!section.children && !section.groups) {
      return `<a class="mobile-nav-link${isSectionCurrent(section) ? " is-current" : ""}" href="${pageHref(section.href)}">${section.label}</a>`;
    }
    const links = section.groups
      ? section.groups
          .map((group) => `<div class="mobile-nav-subgroup"><small>${group.label}</small>${group.items
            .map(([label, href]) => `<a href="${pageHref(href)}">${label}</a>`)
            .join("")}</div>`)
          .join("")
      : section.children
          .map(([label, href]) => `<a href="${pageHref(href)}">${label}</a>`)
          .join("");
    return `<details class="mobile-nav-group"${isSectionCurrent(section) ? " open" : ""}>
      <summary>${section.label}<i data-detail-icon>+</i></summary>
      <div class="${section.groups ? "mobile-nav-groups" : ""}">${links}</div>
    </details>`;
  })
  .join("");

const desktopAssistantTrigger = siteConfig.assistant.enabled
  ? '<button class="site-assistant-trigger" type="button" aria-haspopup="dialog" data-assistant-open><i aria-hidden="true"></i><span><small>Smart search</small><strong>Ask ROADROAM</strong></span></button>'
  : "";
const mobileAssistantTrigger = siteConfig.assistant.enabled
  ? '<button class="mobile-assistant-trigger" type="button" data-assistant-open><span>Ask ROADROAM</span><b>⌕</b></button>'
  : "";

if (headerMount) {
  headerMount.innerHTML = `
    <header class="site-header" data-header>
      <nav class="main-nav main-nav--left" aria-label="Primary product navigation">${desktopNavLeft}</nav>
      <a class="site-brand" href="${pageHref("index.html")}" aria-label="ROADROAM home">
        <img class="site-brand-logo site-brand-logo--dark" src="${assetUrl("brand/roadroam-logo-primary.png")}" alt="ROADROAM" width="1068" height="620" decoding="async" />
        <img class="site-brand-logo site-brand-logo--light" src="${assetUrl("brand/roadroam-logo-reverse.png")}" alt="" width="1068" height="620" decoding="async" />
      </a>
      <div class="header-right-cluster">
        <nav class="main-nav main-nav--right" aria-label="Primary company navigation">${desktopNavRight}</nav>
        <div class="header-actions">
          ${desktopAssistantTrigger}
          <a class="header-cart" href="${pageHref(commerceCartUrl)}" aria-label="Cart with ${commerceCartCount} items">
            <span>Cart</span><b>${commerceCartCount}</b>
          </a>
        </div>
      </div>
      <button class="menu-toggle" type="button" aria-expanded="false" aria-controls="mobile-menu" data-menu-toggle>
        <span></span><span></span><span></span><i class="sr-only">Open menu</i>
      </button>
      <nav class="mobile-menu" id="mobile-menu" aria-label="Mobile navigation" data-mobile-menu>
        ${mobileNav}
        <a class="mobile-cart" href="${pageHref(commerceCartUrl)}"><span>Cart</span><b>${commerceCartCount}</b></a>
        ${mobileAssistantTrigger}
      </nav>
    </header>`;

  renderCommerceCartCount(commerceCartCount);
  document.addEventListener("shopify:cart:lines-update", (event) => {
    const update = event.promise;
    if (!update || typeof update.then !== "function") return;
    update
      .then(({ cart, detail }) => renderCommerceCartCount(cart?.totalQuantity ?? detail?.itemCount))
      .catch((error) => {
        if (error?.name !== "AbortError") console.warn("[roadroam-cart] Cart count update failed:", error);
      });
  });
}

if (footerMount) {
  footerMount.innerHTML = `
    <footer class="site-footer">
      <div class="footer-lead">
        <p aria-label="Connect anywhere. Explore everywhere.">
          <span>Connect anywhere.</span>
          <span>Explore everywhere.</span>
        </p>
      </div>
      <div class="footer-main">
        <div class="footer-brand-column">
          <a class="footer-brand" href="${pageHref("index.html")}"><img src="${assetUrl("brand/roadroam-logo-reverse.png")}" alt="ROADROAM" width="1068" height="620" loading="lazy" decoding="async" /></a>
          <div class="footer-socials"><a href="${siteConfig.social.facebook}" target="_blank" rel="noreferrer" aria-label="Facebook"><img src="${assetUrl("icons/social/facebook.svg")}" alt="" /></a><a href="${siteConfig.social.youtube}" target="_blank" rel="noreferrer" aria-label="YouTube"><img src="${assetUrl("icons/social/youtube.svg")}" alt="" /></a><a href="${siteConfig.social.instagram}" target="_blank" rel="noreferrer" aria-label="Instagram"><img src="${assetUrl("icons/social/instagram.svg")}" alt="" /></a><a href="${siteConfig.social.tiktok}" target="_blank" rel="noreferrer" aria-label="TikTok"><img src="${assetUrl("icons/social/tiktok.svg")}" alt="" /></a><a href="${siteConfig.social.x}" target="_blank" rel="noreferrer" aria-label="X"><img src="${assetUrl("icons/social/x.svg")}" alt="" /></a></div>
          <a class="footer-email" href="mailto:${siteConfig.contactEmail}">
            <span class="footer-email-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><rect x="3" y="6" width="18" height="12" rx="3"/><path d="m4.5 7.5 7.5 5.4 7.5-5.4"/></svg></span>
            <strong>${siteConfig.contactEmail}</strong>
          </a>
        </div>
        <div class="footer-nav">
          <div><strong>RV Leveling</strong><a href="${pageHref("launch/index.html")}">RV Leveling Launch</a></div>
          <div><strong>About</strong><a href="${pageHref("about/index.html")}">Story</a><a href="${pageHref("about/connect/index.html")}">Connect</a></div>
          <div><strong>Orders & coverage</strong><a href="${pageHref("support/shipping/index.html")}">Shipping policy</a><a href="${pageHref("support/returns/index.html")}">Refund policy</a><a href="${pageHref("support/privacy/index.html")}">Privacy policy</a><a href="${pageHref("support/terms/index.html")}">Terms of service</a></div>
        </div>
      </div>
      <div class="footer-bottom"><span>© 2026 ROADROAM · Pre-launch site</span><span class="footer-legal"><a href="${pageHref("support/privacy/index.html")}">Privacy</a><a href="${pageHref("support/terms/index.html")}">Terms</a></span></div>
    </footer>`;
}

if (headerMount && siteConfig.assistant.enabled) {
  body.insertAdjacentHTML("beforeend", `
    <div class="roadroam-assistant" data-assistant aria-hidden="true" hidden>
      <button class="assistant-backdrop" type="button" aria-label="Close ROADROAM smart search" data-assistant-close></button>
      <section class="assistant-panel" role="dialog" aria-modal="true" aria-labelledby="assistant-title">
        <header class="assistant-panel-head">
          <div><small>ROADROAM</small><strong id="assistant-title">Ask ROADROAM</strong></div>
          <button type="button" aria-label="Close ROADROAM smart search" data-assistant-close>×</button>
        </header>
        <div class="assistant-panel-body">
          <form class="assistant-search" role="search" data-assistant-form>
            <label class="sr-only" for="roadroam-assistant-input">Ask ROADROAM</label>
            <input id="roadroam-assistant-input" type="search" autocomplete="off" placeholder="Setup, compatibility, support…" data-assistant-input />
            <button class="assistant-voice" type="button" aria-label="Search by voice" aria-pressed="false" data-assistant-voice hidden><i aria-hidden="true"></i></button>
            <button class="assistant-submit" type="submit">Search</button>
          </form>
          <div class="assistant-prompts" aria-label="Suggested questions">
            <button type="button" data-assistant-prompt="How does Smart Leveling work?">How it works</button>
            <button type="button" data-assistant-prompt="Which RV types are compatible?">Compatibility</button>
            <button type="button" data-assistant-prompt="How do shipping and returns work?">Orders</button>
          </div>
          <div class="assistant-results" aria-live="polite" data-assistant-results></div>
        </div>
      </section>
    </div>`);
}

document.querySelectorAll("[data-campaign-link]").forEach((link) => {
  link.setAttribute("href", campaignHref);
});
document.querySelectorAll("[data-campaign-label]").forEach((label) => {
  label.textContent = campaign.primaryLabel;
});

const currentAboutPageLink = document.querySelector(".about-page-nav .is-current");
const centerCurrentAboutPage = () => {
  const rail = currentAboutPageLink?.parentElement;
  if (!rail || !window.matchMedia("(max-width: 700px)").matches) return;
  rail.scrollLeft = Math.max(0, currentAboutPageLink.offsetLeft - (rail.clientWidth - currentAboutPageLink.offsetWidth) / 2);
};
if (currentAboutPageLink) {
  requestAnimationFrame(centerCurrentAboutPage);
  window.addEventListener("resize", centerCurrentAboutPage);
}

const directoryProfiles = {
  smart: {
    match: "Smart Leveling",
    eyebrow: "Smart Leveling field guide",
    title: "See the whole system",
    items: {
      Overview: ["images/rv-campsite-apache-junction.webp", "System overview"],
      "Precision sensing": ["images/smart-level-device.jpg", "Live sensing"],
      "App guidance": ["images/app-level.png", "Phone guidance"],
      "Solo setup": ["images/rigs/fifth-wheel.webp", "One-person flow"],
      "Installation & portability": ["images/rigs/class-c-motorhome.webp", "Inside the rig"],
      "Kit & compatibility": ["images/app-rv-select.png", "Rig fit"],
    },
  },
  about: {
    match: "About pages",
    eyebrow: "Inside ROADROAM",
    title: "Inside ROADROAM",
    items: {
      Story: ["images/hero/rv-travel-trailer-mountain-life-hero.webp", "Why we exist"],
      Connect: ["images/rv-campsite-apache-junction.webp", "Talk with us"],
    },
  },
  support: {
    match: "Support pages",
    eyebrow: "ROADROAM help center",
    title: "Find your next answer",
    items: {
      "Shipping policy": ["images/rv-road-yosemite.webp", "Orders", "Shipping"],
      "Refund policy": ["images/rigs/fifth-wheel.webp", "Orders", "Refunds"],
      "Privacy policy": ["images/ecosystem/smart-sensing.webp", "Data", "Privacy"],
      "Terms of service": ["images/rv-campsite-lake-powell.webp", "Website", "Terms"],
    },
  },
};

document.querySelectorAll(".section-directory").forEach((directory) => {
  const profileEntry = Object.entries(directoryProfiles).find(([, profile]) =>
    (directory.getAttribute("aria-label") || "").includes(profile.match),
  );
  if (!profileEntry) return;

  const [profileKey, profile] = profileEntry;
  const links = [...directory.querySelectorAll(":scope > a")];
  const hashLink = window.location.hash && links.find((link) => link.hash === window.location.hash);
  if (hashLink) {
    links.forEach((link) => link.classList.remove("is-current"));
    hashLink.classList.add("is-current");
  }
  const currentLabel = links.find((link) => link.classList.contains("is-current"))?.textContent.trim() || links[0]?.textContent.trim();
  directory.classList.add("section-directory--visual", `section-directory--${profileKey}`);
  directory.style.setProperty("--directory-count", links.length);

  const overview = document.createElement("div");
  overview.className = "directory-overview";
  overview.innerHTML = `<div><small>${profile.eyebrow}</small><strong>${profile.title}</strong></div><p>Current view <span>${currentLabel}</span></p>`;

  const setDirectoryCurrent = (activeLink) => {
    if (!activeLink) return;
    links.forEach((item) => {
      item.classList.toggle("is-current", item === activeLink);
      if (item === activeLink) item.setAttribute("aria-current", "page");
      else item.removeAttribute("aria-current");
    });
    const currentView = overview.querySelector("p span");
    if (currentView) currentView.textContent = activeLink.querySelector("strong")?.textContent || activeLink.textContent.trim();
  };

  const track = document.createElement("div");
  track.className = "directory-track";
  links.forEach((link) => {
    const label = link.textContent.trim();
    const [image, kicker, cardLabel] = profile.items[label] || ["images/rv-campsite-apache-junction.webp", "Explore", label];
    link.classList.add("directory-card");
    if (link.classList.contains("is-current")) link.setAttribute("aria-current", "page");
    link.innerHTML = `<img src="${assetUrl(image)}" alt="" /><span class="directory-card-shade"></span><span class="directory-card-copy"><small>${kicker}</small><strong>${cardLabel || label}</strong><b aria-hidden="true">↗</b></span>`;
    link.addEventListener("click", () => setDirectoryCurrent(link));
    track.append(link);
  });

  directory.replaceChildren(overview, track);
  window.addEventListener("hashchange", () => {
    setDirectoryCurrent(links.find((link) => link.hash === window.location.hash));
  });
});

document.querySelectorAll(".coverage-nav").forEach((directory) => {
  const current = directory.querySelector(".is-current");
  if (!current) return;
  window.requestAnimationFrame(() => {
    directory.scrollLeft = Math.max(0, current.offsetLeft - (directory.clientWidth - current.clientWidth) / 2);
  });
});

const header = document.querySelector("[data-header]");
const menuToggle = document.querySelector("[data-menu-toggle]");
const mobileMenu = document.querySelector("[data-mobile-menu]");

let headerFrame = 0;
const setHeaderState = () => {
  if (headerFrame) return;
  headerFrame = window.requestAnimationFrame(() => {
    header?.classList.toggle("is-scrolled", window.scrollY > 24);
    headerFrame = 0;
  });
};
setHeaderState();
window.addEventListener("scroll", setHeaderState, { passive: true });

const closeMenu = () => {
  menuToggle?.setAttribute("aria-expanded", "false");
  mobileMenu?.classList.remove("is-open");
  body.classList.remove("menu-open");
};

menuToggle?.addEventListener("click", () => {
  const open = menuToggle.getAttribute("aria-expanded") !== "true";
  menuToggle.setAttribute("aria-expanded", String(open));
  mobileMenu?.classList.toggle("is-open", open);
  body.classList.toggle("menu-open", open);
});
mobileMenu?.querySelectorAll("a").forEach((link) => link.addEventListener("click", closeMenu));
window.addEventListener("keydown", (event) => event.key === "Escape" && closeMenu());

const campaignBackToTop = document.querySelector("[data-campaign-back-to-top]");
if (campaignBackToTop) {
  // Keep the fixed control outside the campaign's clipped art direction layer.
  // This also avoids iOS/Shopify preview treating the button as a clipped child.
  if (campaignBackToTop.parentElement !== body) body.append(campaignBackToTop);
  let backToTopFrame = 0;
  const syncBackToTop = () => {
    if (backToTopFrame) return;
    backToTopFrame = window.requestAnimationFrame(() => {
      const visible = window.scrollY > Math.max(640, window.innerHeight * 0.8);
      campaignBackToTop.classList.toggle("is-visible", visible);
      campaignBackToTop.tabIndex = visible ? 0 : -1;
      backToTopFrame = 0;
    });
  };

  campaignBackToTop.addEventListener("click", () => {
    const behavior = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
    window.scrollTo({ top: 0, behavior });
  });
  syncBackToTop();
  window.addEventListener("scroll", syncBackToTop, { passive: true });
  window.addEventListener("resize", syncBackToTop);
}

const trackEvent = (name, detail = {}) => {
  const payload = { event: `roadroam_${name}`, page: pageKey, ...detail };
  if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
  window.dispatchEvent(new CustomEvent("roadroam:track", { detail: payload }));
};

const assistantKnowledge = [
  { title: "Smart Leveling pre-launch", summary: "Smart Leveling is ROADROAM’s first system in development for a planned crowdfunding campaign. It is not available for purchase.", href: "launch/index.html", keywords: "smart leveling prototype sensor lean level rv device development crowdfunding first system" },
  { title: "Complete leveling flow", summary: "See the ROADROAM app, block recommendation, adjustment, and confirmation sequence.", href: "launch/index.html#workflow", keywords: "how works flow app campsite adjustment blocks confirm setup" },
  { title: "Installation & calibration", summary: "ROADROAM setup guidance will be published as the product moves closer to launch.", href: "launch/index.html#smart-leveling-faq", keywords: "install installation mount wall bracket calibrate calibration reference set level" },
  { title: "Shipping policy", summary: "ROADROAM offers free standard U.S. shipping, with order processing and delivery timing explained in the shipping policy.", href: "support/shipping/index.html", keywords: "shipping delivery carrier tracking region destination address usps ups fedex free standard military apo fpo" },
  { title: "Refund policy", summary: "Read the 30-day return, refund, exchange, and lifetime manufacturing-defect warranty terms.", href: "support/returns/index.html", keywords: "return returns refund refunds exchange damaged wrong item eligibility warranty defect replacement payment" },
  { title: "Privacy policy", summary: "Learn what information ROADROAM collects, how it is used and disclosed, and what privacy choices are available.", href: "support/privacy/index.html", keywords: "privacy data personal information cookies tracking california ccpa security email opt out" },
  { title: "Terms of service", summary: "Read the terms that govern use of the ROADROAM website, orders, payments, intellectual property, and disputes.", href: "support/terms/index.html", keywords: "terms service orders payments conduct intellectual property liability arbitration california" },
  { title: "ROADROAM Story", summary: "See why ROADROAM began with Smart RV Leveling and how it leads toward simpler technology for life on the road.", href: "about/index.html", keywords: "story about brand vision ecosystem connected rv future leveling roadroam" },
  { title: "Launch status", summary: "Smart Leveling remains in development. ROADROAM is preparing an independent pre-launch path for a planned Kickstarter campaign.", href: "launch/index.html", keywords: "launch kickstarter campaign preorder buy purchase available release date early crew" },
];

const assistant = document.querySelector("[data-assistant]");
const assistantPanel = assistant?.querySelector(".assistant-panel");
const assistantInput = assistant?.querySelector("[data-assistant-input]");
const assistantForm = assistant?.querySelector("[data-assistant-form]");
const assistantResults = assistant?.querySelector("[data-assistant-results]");
const assistantVoice = assistant?.querySelector("[data-assistant-voice]");
let assistantReturnFocus = null;

const normalizeAssistantQuery = (value) => value.toLowerCase().replace(/[^a-z0-9\s&-]/g, " ").replace(/\s+/g, " ").trim();
const assistantStopWords = new Set(["a", "an", "and", "are", "about", "can", "do", "does", "for", "how", "i", "is", "my", "of", "the", "to", "what", "with", "work", "works"]);
const assistantTokens = (value) => normalizeAssistantQuery(value).split(" ").filter((token) => token.length > 1 && !assistantStopWords.has(token));
const renderAssistantResults = (rawQuery) => {
  if (!assistantResults) return;
  const query = normalizeAssistantQuery(rawQuery);
  if (!query) {
    assistantResults.innerHTML = "";
    return;
  }
  const tokens = assistantTokens(query);
  const ranked = assistantKnowledge
    .map((item) => {
      const title = normalizeAssistantQuery(item.title);
      const summary = normalizeAssistantQuery(item.summary);
      const keywords = normalizeAssistantQuery(item.keywords);
      const searchablePhrase = tokens.join(" ");
      const score = (searchablePhrase && title.includes(searchablePhrase) ? 12 : 0) + tokens.reduce((total, token) => {
        if (title.includes(token)) return total + 6;
        if (keywords.includes(token)) return total + 3;
        if (summary.includes(token)) return total + 1;
        return total;
      }, 0);
      return { ...item, score };
    })
    .filter((item) => item.score > 0)
    .sort((a, b) => b.score - a.score)
    .slice(0, 2);

  if (!ranked.length) {
    assistantResults.innerHTML = `<div class="assistant-no-result"><h3>Ask our team.</h3><a href="mailto:${siteConfig.contactEmail}">${siteConfig.contactEmail} <span>↗</span></a></div>`;
    trackEvent("assistant_no_result", { query });
    return;
  }

  assistantResults.innerHTML = `<div class="assistant-result-list">${ranked
    .map((item, index) => `<article${index === 0 ? ' class="is-primary"' : ""}><div><small>${index === 0 ? "Best match" : "Related"}</small><h3>${item.title}</h3>${index === 0 ? `<p>${item.summary}</p>` : ""}</div><a href="${pageHref(item.href)}">Open <span>↗</span></a></article>`)
    .join("")}</div>`;
  trackEvent("assistant_search", { query, result: ranked[0].title });
};

const openAssistant = (trigger) => {
  if (!assistant) return;
  assistantReturnFocus = trigger || document.activeElement;
  closeMenu();
  assistant.hidden = false;
  assistant.setAttribute("aria-hidden", "false");
  body.classList.add("assistant-open");
  window.requestAnimationFrame(() => assistant.classList.add("is-open"));
  window.setTimeout(() => assistantInput?.focus(), reduceMotion ? 0 : 180);
  trackEvent("assistant_open");
};

const closeAssistant = () => {
  if (!assistant || assistant.hidden) return;
  assistant.classList.remove("is-open");
  assistant.setAttribute("aria-hidden", "true");
  body.classList.remove("assistant-open");
  window.setTimeout(() => { assistant.hidden = true; }, reduceMotion ? 0 : 220);
  assistantReturnFocus?.focus?.();
};

document.querySelectorAll("[data-assistant-open]").forEach((trigger) => trigger.addEventListener("click", () => openAssistant(trigger)));
assistant?.querySelectorAll("[data-assistant-close]").forEach((trigger) => trigger.addEventListener("click", closeAssistant));
assistant?.querySelectorAll("[data-assistant-prompt]").forEach((trigger) => trigger.addEventListener("click", () => {
  if (assistantInput) assistantInput.value = trigger.dataset.assistantPrompt || "";
  renderAssistantResults(assistantInput?.value || "");
}));
assistantForm?.addEventListener("submit", (event) => {
  event.preventDefault();
  renderAssistantResults(assistantInput?.value || "");
});

const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
if (assistantVoice && SpeechRecognition) {
  assistantVoice.hidden = false;
  const recognition = new SpeechRecognition();
  recognition.lang = siteConfig.locale;
  recognition.interimResults = false;
  recognition.maxAlternatives = 1;
  let voiceListening = false;

  assistantVoice.addEventListener("click", () => {
    if (voiceListening) {
      recognition.stop();
      return;
    }
    try { recognition.start(); } catch (_) { /* Ignore repeated-start errors. */ }
  });

  recognition.addEventListener("start", () => {
    voiceListening = true;
    assistantVoice.classList.add("is-listening");
    assistantVoice.setAttribute("aria-pressed", "true");
    assistantVoice.setAttribute("aria-label", "Stop voice search");
  });

  recognition.addEventListener("end", () => {
    voiceListening = false;
    assistantVoice.classList.remove("is-listening");
    assistantVoice.setAttribute("aria-pressed", "false");
    assistantVoice.setAttribute("aria-label", "Search by voice");
  });

  recognition.addEventListener("result", (event) => {
    const transcript = event.results?.[0]?.[0]?.transcript || "";
    if (assistantInput) assistantInput.value = transcript;
    renderAssistantResults(transcript);
  });

  recognition.addEventListener("error", () => {
    voiceListening = false;
    assistantVoice.classList.remove("is-listening");
    assistantVoice.setAttribute("aria-pressed", "false");
    assistantVoice.setAttribute("aria-label", "Search by voice");
    if (assistantResults) assistantResults.innerHTML = `<div class="assistant-no-result"><h3>Voice input is unavailable.</h3><a href="mailto:${siteConfig.contactEmail}">Keep typing <span>↗</span></a></div>`;
  });
}

assistantPanel?.addEventListener("keydown", (event) => {
  if (event.key !== "Tab") return;
  const focusable = [...assistantPanel.querySelectorAll('button:not([hidden]), a[href], input:not([disabled])')];
  if (!focusable.length) return;
  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
  if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
});

window.addEventListener("keydown", (event) => {
  if (event.key === "Escape") closeAssistant();
  if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
    event.preventDefault();
    openAssistant(document.querySelector("[data-assistant-open]"));
  }
});

document.querySelectorAll("[data-track]").forEach((element) => {
  element.addEventListener("click", () => trackEvent(element.dataset.track, { href: element.getAttribute("href") || "" }));
});

document.querySelectorAll("[data-form]").forEach((form) => {
  form.addEventListener("submit", (event) => {
    event.preventDefault();
    const required = [...form.querySelectorAll("[required]")];
    const invalid = required.find((field) => !field.checkValidity());
    if (invalid) {
      invalid.reportValidity();
      return;
    }
    if (form.dataset.mailto) {
      const formData = new FormData(form);
      const subject = formData.get("topic") || form.dataset.mailSubject || "ROADROAM website inquiry";
      const message = [...formData.entries()].filter(([, value]) => String(value).trim()).map(([key, value]) => `${key}: ${value}`).join("\n");
      trackEvent(form.dataset.trackForm || "email_contact", { form: form.id || "contact", subject: String(subject) });
      window.location.href = `mailto:${form.dataset.mailto}?subject=${encodeURIComponent(String(subject))}&body=${encodeURIComponent(message)}`;
      return;
    }
    const note = form.parentElement?.querySelector("[data-form-note]") || form.querySelector("[data-form-note]");
    if (note) {
      note.textContent = "Preview confirmed. We’ll connect the live form before launch.";
      note.classList.add("is-success");
    }
    trackEvent(form.dataset.trackForm || "form_submit", { form: form.id || form.getAttribute("aria-label") || "unnamed" });
    form.reset();
  });
});

// The controls are first-party HTML so a visitor never waits for a vendor
// script before seeing the signup. Klaviyo's browser-safe subscription API is
// used only after the visitor submits the form.
const waitlistJoinedKey = "roadroam.launch.waitlist.joined";
const hasWaitlistCookie = () => document.cookie.split(";").some((part) => part.trim() === "rr_waitlist_joined=1");
const hasJoinedWaitlist = () => {
  try {
    return hasWaitlistCookie() || window.localStorage.getItem(waitlistJoinedKey) === "true";
  } catch {
    return hasWaitlistCookie();
  }
};
const rememberWaitlistJoin = () => {
  try {
    window.localStorage.setItem(waitlistJoinedKey, "true");
  } catch {
    // Strict privacy modes can disable persistent storage. The current page
    // still moves to the confirmed state after a successful request.
  }
  document.cookie = "rr_waitlist_joined=1; Max-Age=31536000; Path=/; SameSite=Lax; Secure";
};

document.querySelectorAll("[data-waitlist-live-form]").forEach((form) => {
  const shell = form.closest(".launch-waitlist");
  const email = form.querySelector('input[type="email"]');
  const button = form.querySelector('button[type="submit"]');
  const trap = form.querySelector('[name="website"]');
  const status = shell?.querySelector("[data-waitlist-status]");
  const memberState = shell?.querySelector("[data-waitlist-member-state]");
  const memberMessage = shell?.querySelector("[data-waitlist-member-message]");
  const kickstarter = shell?.querySelector("[data-waitlist-kickstarter]");
  const consent = shell?.querySelector("[data-waitlist-consent]");
  const companyId = form.dataset.klaviyoCompanyId;
  const listId = form.dataset.klaviyoListId;

  if (!shell || !email || !button || !status || !memberState || !companyId || !listId) return;

  const setStatus = (message, state = "") => {
    status.textContent = message;
    status.classList.remove("is-success", "is-error", "is-info");
    if (state) status.classList.add(`is-${state}`);
  };
  const showJoinedState = (returning = false) => {
    form.hidden = true;
    if (consent) consent.hidden = true;
    memberState.hidden = false;
    if (kickstarter) kickstarter.hidden = false;
    if (memberMessage) memberMessage.textContent = returning
      ? "You’re already on the list."
      : "You’re on the list.";
    setStatus("");
  };

  if (hasJoinedWaitlist()) {
    showJoinedState(true);
    return;
  }

  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    if (!form.checkValidity()) {
      email.reportValidity();
      return;
    }
    if (trap?.value) {
      form.reset();
      return;
    }

    const originalLabel = button.textContent;
    const controller = new AbortController();
    const timeoutId = window.setTimeout(() => controller.abort(), 12000);
    button.disabled = true;
    button.setAttribute("aria-busy", "true");
    button.textContent = "Joining…";
    setStatus("Joining the ROADROAM waitlist…", "info");

    try {
      const endpoint = new URL("https://a.klaviyo.com/client/subscriptions");
      endpoint.searchParams.set("company_id", companyId);
      const response = await fetch(endpoint, {
        method: "POST",
        mode: "cors",
        headers: {
          Accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
          revision: "2026-07-15"
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              custom_source: "ROADROAM Launch page",
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email.value.trim(),
                    subscriptions: {
                      email: {marketing: {consent: "SUBSCRIBED"}}
                    }
                  }
                }
              }
            },
            relationships: {
              list: {data: {type: "list", id: listId}}
            }
          }
        }),
        signal: controller.signal
      });

      if (!response.ok) throw new Error(`Waitlist request failed (${response.status})`);

      form.reset();
      rememberWaitlistJoin();
      showJoinedState(false);
      trackEvent("waitlist_form_submitted", {form: "launch_waitlist", provider: "Klaviyo"});
    } catch (error) {
      button.disabled = false;
      button.textContent = originalLabel;
      setStatus("We couldn’t add you right now. Check your connection and try again.", "error");
      trackEvent("waitlist_form_error", {
        form: "launch_waitlist",
        reason: error?.name === "AbortError" ? "timeout" : "request"
      });
    } finally {
      window.clearTimeout(timeoutId);
      button.removeAttribute("aria-busy");
    }
  });
});

document.querySelectorAll("[data-launch-video]").forEach((stage) => {
  const video = stage.querySelector("video.launch-feature-video");
  const playButton = stage.querySelector("[data-launch-video-play]");
  if (!video || !playButton) return;

  if (!video.currentSrc && !video.getAttribute("src") && video.dataset.localVideo) {
    video.src = video.dataset.localVideo;
  }

  const syncLaunchVideo = () => {
    const isPlaying = !video.paused && !video.ended;
    if (video.currentTime > 0 || isPlaying) stage.classList.add("has-started");
    stage.classList.toggle("is-playing", isPlaying);
    playButton.setAttribute("aria-label", isPlaying
      ? "Pause ROADROAM Smart Leveling story"
      : "Play ROADROAM Smart Leveling story");
  };

  playButton.addEventListener("click", () => {
    if (video.paused || video.ended) {
      video.play().catch(syncLaunchVideo);
    } else {
      video.pause();
    }
  });
  video.addEventListener("play", syncLaunchVideo);
  video.addEventListener("pause", syncLaunchVideo);
  video.addEventListener("ended", syncLaunchVideo);
  syncLaunchVideo();
});

const filterButtons = document.querySelectorAll("[data-faq-filter]");
const faqGroups = document.querySelectorAll("[data-faq-group]");
if (faqGroups.length) {
  const faqEntities = [...faqGroups].flatMap((group) => [...group.querySelectorAll("details")].map((detail) => ({
    "@type": "Question",
    name: detail.querySelector("summary")?.textContent.replace(/[+−]$/, "").trim() || "",
    acceptedAnswer: {
      "@type": "Answer",
      text: detail.querySelector("p")?.textContent.trim() || "",
    },
  }))).filter((entity) => entity.name && entity.acceptedAnswer.text);
  if (faqEntities.length) {
    const faqSchema = document.createElement("script");
    faqSchema.type = "application/ld+json";
    faqSchema.textContent = JSON.stringify({ "@context": "https://schema.org", "@type": "FAQPage", mainEntity: faqEntities });
    document.head.append(faqSchema);
  }
}

const initLaunchFaq = (root = document) => {
  const modules = [];
  if (root instanceof Element && root.matches("[data-launch-faq]")) modules.push(root);
  root.querySelectorAll?.("[data-launch-faq]").forEach((module) => modules.push(module));

  modules.forEach((module) => {
  if (module.dataset.launchFaqReady === "true") return;
  module.dataset.launchFaqReady = "true";
  const buttons = [...module.querySelectorAll("[data-launch-faq-filter]")];
  const clusters = [...module.querySelectorAll("[data-launch-faq-category]")];
  const status = module.querySelector("[data-launch-faq-status]");
  const pageIndicator = module.querySelector("[data-launch-faq-page]");
  const pager = module.querySelector("[data-launch-faq-pager]");
  const previousButton = module.querySelector("[data-launch-faq-prev]");
  const nextButton = module.querySelector("[data-launch-faq-next]");
  const pageSize = Math.max(1, Number(module.dataset.faqPageSize) || 4);
  let activeCategory = buttons.find((button) => button.classList.contains("is-active"))?.dataset.launchFaqFilter
    || buttons[0]?.dataset.launchFaqFilter;
  let currentPage = 0;

  buttons.forEach((button) => {
    const cluster = clusters.find((item) => item.dataset.launchFaqCategory === button.dataset.launchFaqFilter);
    const count = cluster?.querySelectorAll("details").length || 0;
    const counter = button.querySelector("small");
    if (counter) counter.textContent = String(count).padStart(2, "0");
  });

  const closeAllAnswers = () => {
    module.querySelectorAll("details[open]").forEach((detail) => {
      detail.open = false;
    });
  };

  const renderPage = () => {
    const activeCluster = clusters.find((cluster) => cluster.dataset.launchFaqCategory === activeCategory);
    const questions = activeCluster ? [...activeCluster.querySelectorAll("details")] : [];
    const pageCount = Math.max(1, Math.ceil(questions.length / pageSize));
    currentPage = Math.min(Math.max(currentPage, 0), pageCount - 1);
    const start = currentPage * pageSize;
    const end = Math.min(start + pageSize, questions.length);

    questions.forEach((detail, index) => {
      detail.hidden = index < start || index >= end;
      detail.open = false;
    });

    if (status) {
      status.textContent = questions.length
        ? (pageCount === 1 ? `${questions.length} questions.` : `Showing ${start + 1}–${end} of ${questions.length} questions.`)
        : "No questions in this category yet.";
    }
    if (pager) pager.hidden = pageCount === 1;
    if (pageIndicator) {
      pageIndicator.textContent = `${String(currentPage + 1).padStart(2, "0")} / ${String(pageCount).padStart(2, "0")}`;
    }
    if (previousButton) previousButton.disabled = currentPage === 0;
    if (nextButton) nextButton.disabled = currentPage >= pageCount - 1;
  };

  const selectCategory = (target, activeButton, shouldTrack = true) => {
    activeCategory = target;
    currentPage = 0;
    closeAllAnswers();

    clusters.forEach((cluster) => {
      const show = cluster.dataset.launchFaqCategory === target;
      cluster.hidden = !show;
      cluster.querySelectorAll("details").forEach((detail) => {
        detail.open = false;
        detail.hidden = false;
      });
    });

    buttons.forEach((button) => {
      const selected = button === activeButton;
      button.classList.toggle("is-active", selected);
      button.setAttribute("aria-pressed", String(selected));
    });

    renderPage();

    if (shouldTrack && window.matchMedia("(max-width: 760px)").matches) {
      activeButton?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
    }

    if (shouldTrack) trackEvent("launch_faq_filter", { category: target });
  };

  buttons.forEach((button) => {
    button.addEventListener("click", () => selectCategory(button.dataset.launchFaqFilter, button));
  });

  module.querySelectorAll("details").forEach((detail) => {
    detail.addEventListener("toggle", () => {
      if (!detail.open) return;
      module.querySelectorAll("details[open]").forEach((openDetail) => {
        if (openDetail !== detail) openDetail.open = false;
      });
    });
  });

  previousButton?.addEventListener("click", () => {
    if (currentPage === 0) return;
    currentPage -= 1;
    renderPage();
    trackEvent("launch_faq_page", { category: activeCategory, page: currentPage + 1 });
  });

  nextButton?.addEventListener("click", () => {
    const activeCluster = clusters.find((cluster) => cluster.dataset.launchFaqCategory === activeCategory);
    const pageCount = Math.ceil((activeCluster?.querySelectorAll("details").length || 0) / pageSize);
    if (currentPage >= pageCount - 1) return;
    currentPage += 1;
    renderPage();
    trackEvent("launch_faq_page", { category: activeCategory, page: currentPage + 1 });
  });

  const initialButton = buttons.find((button) => button.dataset.launchFaqFilter === activeCategory) || buttons[0];
  if (initialButton) selectCategory(initialButton.dataset.launchFaqFilter, initialButton, false);
  });
};

initLaunchFaq();
document.addEventListener("shopify:section:load", (event) => initLaunchFaq(event.target));

filterButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const target = button.dataset.faqFilter;
    filterButtons.forEach((item) => item.classList.toggle("is-active", item === button));
    faqGroups.forEach((group) => {
      const show = target === "all" || group.dataset.faqGroup === target;
      group.hidden = !show;
      group.querySelectorAll("details").forEach((detail) => {
        detail.hidden = false;
      });
    });
  });
});

const supportSearch = document.querySelector(".support-search");
const runSupportSearch = (rawQuery) => {
  const query = rawQuery.trim().toLowerCase();
  let firstMatch = null;

  filterButtons.forEach((button) => button.classList.toggle("is-active", button.dataset.faqFilter === "all"));
  faqGroups.forEach((group) => {
    let groupHasMatch = !query;
    group.querySelectorAll("details").forEach((detail) => {
      const matches = !query || detail.textContent.toLowerCase().includes(query);
      detail.hidden = !matches;
      detail.open = Boolean(query && matches);
      if (matches) groupHasMatch = true;
      const icon = detail.querySelector("summary span:last-child");
      if (icon) icon.textContent = detail.open ? "−" : "+";
      if (matches && !firstMatch) firstMatch = detail;
    });
    group.hidden = !groupHasMatch;
  });

  firstMatch?.scrollIntoView({ behavior: "smooth", block: "center" });
  trackEvent("support_search", { query });
};

supportSearch?.addEventListener("submit", (event) => {
  event.preventDefault();
  const rawQuery = supportSearch.querySelector('input[type="search"]')?.value.trim() || "";
  if (!faqGroups.length) {
    trackEvent("support_search", { query: rawQuery.toLowerCase() });
    window.location.href = `${pageHref("support/faq/index.html")}?q=${encodeURIComponent(rawQuery)}`;
    return;
  }
  runSupportSearch(rawQuery);
});

const requestedSupportQuery = new URLSearchParams(window.location.search).get("q");
if (requestedSupportQuery && supportSearch && faqGroups.length) {
  const input = supportSearch.querySelector('input[type="search"]');
  if (input) input.value = requestedSupportQuery;
  window.requestAnimationFrame(() => runSupportSearch(requestedSupportQuery));
}

document.querySelectorAll("details").forEach((detail) => {
  const initialIcon = detail.querySelector("summary [data-detail-icon], summary span:last-child");
  if (initialIcon && detail.open) initialIcon.textContent = "−";
  detail.addEventListener("toggle", () => {
    const icon = detail.querySelector("summary [data-detail-icon], summary span:last-child");
    if (icon) icon.textContent = detail.open ? "−" : "+";
  });
});

const revealItems = document.querySelectorAll("[data-reveal]");
const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// Launch motion controller. Both posters and motion sources stay out of the
// initial request queue until their frame is close to the viewport. Mobile uses
// a dedicated lightweight stream; every motion that is actually on screen may
// play, while off-screen motion is paused and later released.
const campaignMotionVideos = new Set();
const motionMobile = window.matchMedia("(max-width: 760px)");
const motionReduce = window.matchMedia("(prefers-reduced-motion: reduce)");
const motionSaveData = Boolean(navigator.connection?.saveData);
const visibleMotion = new Map();
const activeMotion = new Set();
const blockedMotion = new Set();
const motionRetryTimers = new WeakMap();
const motionRetryCounts = new WeakMap();
let reconcileFrame = 0;

const clearMotionRetry = (video, resetCount = true) => {
  const timer = motionRetryTimers.get(video);
  if (timer) window.clearTimeout(timer);
  motionRetryTimers.delete(video);
  if (resetCount) motionRetryCounts.delete(video);
};

const setMotionState = (video, state) => {
  video.dataset.motionState = state;
};

const attachMotionPoster = (video) => {
  if (!video.poster && video.dataset.motionPoster) video.poster = video.dataset.motionPoster;
};

const rememberAndRemoveNativeSource = (video) => {
  const source = video.querySelector("source[data-motion-native-mobile]");
  if (!source) return;
  const sourceValue = source.getAttribute("src");
  if (sourceValue) source.dataset.motionNativeSrc = sourceValue;
  source.removeAttribute("src");
};

const restoreNativeSource = (video) => {
  const source = video.querySelector("source[data-motion-native-mobile]");
  if (source && !source.getAttribute("src") && source.dataset.motionNativeSrc) {
    source.setAttribute("src", source.dataset.motionNativeSrc);
    return true;
  }
  return false;
};

const pauseMotion = (video) => {
  clearMotionRetry(video);
  if (!video.paused) video.pause();
  if (!video.matches('[data-motion-state="error"], [data-motion-state="blocked"], [data-motion-state="reduced"]')) {
    setMotionState(video, video.currentSrc ? "paused" : "idle");
  }
};

const showReducedMotionPoster = (video) => {
  if (video.dataset.motionState === "reduced") return;
  attachMotionPoster(video);
  pauseMotion(video);
  rememberAndRemoveNativeSource(video);
  video.autoplay = false;
  video.removeAttribute("autoplay");
  video.preload = "none";
  video.removeAttribute("src");
  video.dataset.motionLoadedSource = "";
  video.load();
  setMotionState(video, "reduced");
};

const motionSource = (video) => {
  const preferMobile = motionMobile.matches && !video.dataset.motionForceDesktop;
  return (preferMobile ? video.dataset.motionMobile : video.dataset.motionDesktop)
    || video.dataset.motionDesktop
    || video.dataset.motionMobile
    || "";
};

const detachMotion = (video) => {
  pauseMotion(video);
  rememberAndRemoveNativeSource(video);
  video.autoplay = false;
  video.removeAttribute("autoplay");
  video.preload = "none";
  video.removeAttribute("src");
  video.load();
  video.dataset.motionLoadedSource = "";
  video.dataset.motionForceDesktop = "";
  blockedMotion.delete(video);
  setMotionState(video, "idle");
};

const attachMotion = (video) => {
  if (motionReduce.matches) {
    showReducedMotionPoster(video);
    return false;
  }

  const source = motionSource(video);
  if (!source) return false;
  if (video.dataset.motionLoadedSource === source) return true;

  const restoredNativeSource = restoreNativeSource(video);
  if (restoredNativeSource) video.load();
  const resolvedSource = new URL(source, document.baseURI).href;
  const nativeMobileSource = motionMobile.matches
    ? video.querySelector("source[data-motion-native-mobile]")
    : null;
  if (nativeMobileSource?.src && new URL(nativeMobileSource.src, document.baseURI).href === resolvedSource) {
    video.dataset.motionLoadedSource = source;
    setMotionState(video, "loading");
    return true;
  }
  if (video.currentSrc === resolvedSource) {
    video.dataset.motionLoadedSource = source;
    setMotionState(video, video.readyState >= 3 ? "ready" : "loading");
    return true;
  }

  attachMotionPoster(video);
  video.autoplay = true;
  video.muted = true;
  video.defaultMuted = true;
  video.loop = true;
  video.playsInline = true;
  video.setAttribute("muted", "");
  video.setAttribute("autoplay", "");
  video.setAttribute("playsinline", "");
  video.setAttribute("webkit-playsinline", "");
  video.preload = "metadata";
  video.src = source;
  video.dataset.motionLoadedSource = source;
  setMotionState(video, "loading");
  video.load();
  return true;
};

const scheduleMotionRetry = (video) => {
  if (document.hidden || motionReduce.matches || !activeMotion.has(video) || motionRetryTimers.has(video)) return;
  const attempt = (motionRetryCounts.get(video) || 0) + 1;
  motionRetryCounts.set(video, attempt);
  if (attempt > 4) return;
  const delays = [180, 420, 900, 1600];
  const timer = window.setTimeout(() => {
    motionRetryTimers.delete(video);
    if (activeMotion.has(video) && video.paused) playMotion(video);
  }, delays[attempt - 1]);
  motionRetryTimers.set(video, timer);
};

const playMotion = async (video) => {
  if (document.hidden || motionReduce.matches || !activeMotion.has(video)) return;
  if (!attachMotion(video)) return;

  video.muted = true;
  video.defaultMuted = true;
  video.playsInline = true;
  video.autoplay = true;
  video.preload = "auto";
  try {
    await video.play();
    blockedMotion.delete(video);
    clearMotionRetry(video);
    delete video.dataset.motionError;
  } catch (error) {
    if (error?.name === "AbortError") return;
    blockedMotion.add(video);
    video.dataset.motionError = `${error?.name || "PlaybackError"}: ${error?.message || "Playback could not start"}`;
    setMotionState(video, "blocked");
    scheduleMotionRetry(video);
  }
};

const scheduleMotionReconcile = () => {
  if (reconcileFrame) return;
  reconcileFrame = window.requestAnimationFrame(() => {
    reconcileFrame = 0;

    campaignMotionVideos.forEach((video) => {
      if (!video.isConnected) campaignMotionVideos.delete(video);
    });

    if (motionReduce.matches) {
      activeMotion.clear();
      campaignMotionVideos.forEach(showReducedMotionPoster);
      return;
    }

    const center = window.innerHeight / 2;
    const preloadMargin = window.innerHeight * .32;
    visibleMotion.clear();
    campaignMotionVideos.forEach((video) => {
      const rect = video.getBoundingClientRect();
      const isNearViewport = rect.bottom > -preloadMargin && rect.top < window.innerHeight + preloadMargin;
      if (!isNearViewport) return;
      const visibleHeight = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
      visibleMotion.set(video, rect.height ? visibleHeight / rect.height : 0);
    });

    const candidates = [...visibleMotion.entries()]
      .filter(([, ratio]) => ratio > 0)
      .sort(([videoA, ratioA], [videoB, ratioB]) => {
        if (ratioA !== ratioB) return ratioB - ratioA;
        const distanceA = Math.abs(videoA.getBoundingClientRect().top + videoA.clientHeight / 2 - center);
        const distanceB = Math.abs(videoB.getBoundingClientRect().top + videoB.clientHeight / 2 - center);
        return distanceA - distanceB;
      });
    const selectedVideos = motionSaveData ? candidates.slice(0, 1) : candidates;
    const selected = new Set(selectedVideos.map(([video]) => video));

    activeMotion.clear();
    selected.forEach((video) => activeMotion.add(video));
    campaignMotionVideos.forEach((video) => {
      if (selected.has(video)) playMotion(video);
      else pauseMotion(video);
    });
  });
};

const motionPosterObserver = typeof IntersectionObserver === "function"
  ? new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      attachMotionPoster(entry.target);
      observer.unobserve(entry.target);
    });
  }, { rootMargin: "120% 0px 120% 0px", threshold: 0 })
  : null;

const motionObserver = typeof IntersectionObserver === "function"
  ? new IntersectionObserver((entries) => {
    if (entries.length) scheduleMotionReconcile();
  }, { rootMargin: "32% 0px 32% 0px", threshold: [0, .01, .25, .6] })
  : null;

const motionMemoryObserver = typeof IntersectionObserver === "function"
  ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting || !entry.target.currentSrc) return;
      const video = entry.target;
      window.setTimeout(() => {
        if (!activeMotion.has(video) && video.isConnected) detachMotion(video);
      }, 1800);
    });
  }, { rootMargin: "220% 0px 220% 0px", threshold: 0 })
  : null;

const initializeMotionVideo = (video) => {
  if (campaignMotionVideos.has(video)) return;
  campaignMotionVideos.add(video);
  video.controls = false;
  video.muted = true;
  video.defaultMuted = true;
  video.loop = true;
  video.playsInline = true;
  video.removeAttribute("controls");
  video.setAttribute("muted", "");
  video.setAttribute("playsinline", "");
  video.setAttribute("webkit-playsinline", "");
  attachMotionPoster(video);

  video.addEventListener("playing", () => {
    blockedMotion.delete(video);
    clearMotionRetry(video);
    setMotionState(video, "playing");
  });
  video.addEventListener("canplay", () => {
    if (activeMotion.has(video) && video.paused) playMotion(video);
  });
  video.addEventListener("waiting", () => {
    if (activeMotion.has(video)) setMotionState(video, "loading");
  });
  video.addEventListener("stalled", () => {
    if (!activeMotion.has(video)) return;
    setMotionState(video, "loading");
    window.setTimeout(() => playMotion(video), 900);
  });
  video.addEventListener("error", () => {
    const mobileFailed = motionMobile.matches
      && !video.dataset.motionForceDesktop
      && video.dataset.motionMobile
      && video.dataset.motionDesktop
      && video.dataset.motionMobile !== video.dataset.motionDesktop;
    if (mobileFailed) {
      video.dataset.motionForceDesktop = "true";
      video.dataset.motionLoadedSource = "";
      rememberAndRemoveNativeSource(video);
      video.removeAttribute("src");
      video.load();
      window.setTimeout(() => playMotion(video), 120);
      return;
    }
    blockedMotion.delete(video);
    clearMotionRetry(video);
    setMotionState(video, "error");
  });

  if (motionReduce.matches) showReducedMotionPoster(video);
  else video.setAttribute("autoplay", "");
  motionPosterObserver?.observe(video);
  motionObserver?.observe(video);
  motionMemoryObserver?.observe(video);
};

const motionVideosWithin = (root) => {
  const videos = [];
  if (root instanceof Element && root.matches("video[data-campaign-motion]")) videos.push(root);
  root.querySelectorAll?.("video[data-campaign-motion]").forEach((video) => videos.push(video));
  return videos;
};

const registerMotionVideos = (root = document) => {
  motionVideosWithin(root).forEach(initializeMotionVideo);
  scheduleMotionReconcile();
};

const unregisterMotionVideos = (root) => {
  motionVideosWithin(root).forEach((video) => {
    motionPosterObserver?.unobserve(video);
    motionObserver?.unobserve(video);
    motionMemoryObserver?.unobserve(video);
    clearMotionRetry(video);
    activeMotion.delete(video);
    blockedMotion.delete(video);
    campaignMotionVideos.delete(video);
    if (!video.paused) video.pause();
  });
  scheduleMotionReconcile();
};

registerMotionVideos();

const retryVisibleMotion = () => {
  blockedMotion.forEach((video) => {
    if (activeMotion.has(video)) playMotion(video);
  });
  scheduleMotionReconcile();
};

document.addEventListener("pointerdown", retryVisibleMotion, { passive: true });
document.addEventListener("touchstart", retryVisibleMotion, { passive: true });
window.addEventListener("scroll", scheduleMotionReconcile, { passive: true });
window.addEventListener("resize", scheduleMotionReconcile, { passive: true });
window.addEventListener("orientationchange", scheduleMotionReconcile, { passive: true });
window.addEventListener("focus", retryVisibleMotion);
window.addEventListener("online", retryVisibleMotion);
window.addEventListener("pageshow", scheduleMotionReconcile);
document.addEventListener("shopify:section:load", (event) => registerMotionVideos(event.target));
document.addEventListener("shopify:section:unload", (event) => unregisterMotionVideos(event.target));
document.addEventListener("visibilitychange", () => {
  if (document.hidden) campaignMotionVideos.forEach(pauseMotion);
  else scheduleMotionReconcile();
});
motionMobile.addEventListener?.("change", () => {
  campaignMotionVideos.forEach(detachMotion);
  scheduleMotionReconcile();
});
motionReduce.addEventListener?.("change", () => {
  if (motionReduce.matches) campaignMotionVideos.forEach(showReducedMotionPoster);
  else {
    campaignMotionVideos.forEach((video) => {
      setMotionState(video, "idle");
    });
  }
  scheduleMotionReconcile();
});

// Keep content stable at first paint. Scroll-triggered opacity and transform
// animations made slower devices feel as if sections were still loading.
revealItems.forEach((item) => item.classList.add("is-visible"));

const heroCarousel = document.querySelector("[data-hero-carousel]");
if (heroCarousel) {
  const slides = [...heroCarousel.querySelectorAll("[data-hero-slide]")].filter((slide) => !slide.hidden);
  const dots = [...heroCarousel.querySelectorAll("[data-hero-dot]")].filter((dot) => !dot.hidden);
  const previous = heroCarousel.querySelector("[data-hero-prev]");
  const next = heroCarousel.querySelector("[data-hero-next]");
  const toggle = heroCarousel.querySelector("[data-hero-toggle]");
  const currentStatus = heroCarousel.querySelector("[data-hero-current]");
  let activeIndex = 0;
  let timer = null;
  let isPaused = reduceMotion;
  let gesturePointerId = null;
  let gestureStartX = 0;
  let gestureStartY = 0;
  let gestureStartTime = 0;
  let gestureLastX = 0;
  let gestureLastTime = 0;
  let gestureDeltaX = 0;
  let gestureVelocity = 0;
  let gestureAxis = "";
  let settleFrame = 0;
  let blockClickUntil = 0;

  const warmSlideImage = (index) => {
    const image = slides[(index + slides.length) % slides.length]?.querySelector("img");
    if (!image || image.complete) return;
    image.loading = "eager";
    image.decoding = "async";
  };

  const clearGestureStyles = () => {
    heroCarousel.classList.remove("is-dragging", "is-settling");
    slides.forEach((slide) => {
      slide.style.removeProperty("transform");
      slide.style.removeProperty("will-change");
    });
  };

  const renderSlide = (index) => {
    if (settleFrame) window.cancelAnimationFrame(settleFrame);
    settleFrame = 0;
    clearGestureStyles();
    activeIndex = (index + slides.length) % slides.length;
    heroCarousel.dataset.heroIndex = String(activeIndex);
    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === activeIndex;
      slide.classList.toggle("is-active", active);
      slide.setAttribute("aria-hidden", String(!active));
      slide.style.opacity = active ? "1" : "0";
      slide.style.zIndex = active ? "1" : "0";
    });
    dots.forEach((dot, dotIndex) => {
      const active = dotIndex === activeIndex;
      dot.classList.toggle("is-active", active);
      if (active) dot.setAttribute("aria-current", "true");
      else dot.removeAttribute("aria-current");
    });
    if (currentStatus) currentStatus.textContent = String(activeIndex + 1).padStart(2, "0");
    if (activeIndex !== 0) warmSlideImage(activeIndex + 1);
  };

  const applyGestureFrame = (position, direction) => {
    const width = Math.max(1, heroCarousel.clientWidth);
    const outgoing = slides[activeIndex];
    const incomingIndex = (activeIndex + direction + slides.length) % slides.length;
    const incoming = slides[incomingIndex];
    const incomingOrigin = direction > 0 ? width : -width;
    const progress = Math.min(1, Math.abs(position) / width);

    slides.forEach((slide, index) => {
      if (index === activeIndex || index === incomingIndex) return;
      slide.style.opacity = "0";
      slide.style.zIndex = "0";
      slide.style.transform = "translate3d(0, 0, 0) scale(1)";
    });

    outgoing.style.opacity = "1";
    outgoing.style.zIndex = "3";
    outgoing.style.transform = `translate3d(${position}px, 0, 0) scale(${1 - progress * 0.014})`;
    incoming.style.opacity = "1";
    incoming.style.zIndex = "2";
    incoming.style.transform = `translate3d(${incomingOrigin + position}px, 0, 0) scale(${0.985 + progress * 0.015})`;
  };

  const settleGesture = ({ commit, direction, animate = true }) => {
    const width = Math.max(1, heroCarousel.clientWidth);
    const startPosition = gestureDeltaX;
    const target = commit ? (direction > 0 ? -width : width) : 0;
    const targetIndex = activeIndex + (commit ? direction : 0);

    gesturePointerId = null;
    gestureAxis = "";
    heroCarousel.classList.remove("is-dragging");

    if (!animate || reduceMotion) {
      renderSlide(targetIndex);
      startCarousel();
      return;
    }

    heroCarousel.classList.add("is-settling");
    let position = startPosition;
    let velocity = gestureVelocity;
    let previousTime = performance.now();
    const startedAt = previousTime;
    const stiffness = 320;
    const damping = 25;

    const spring = (now) => {
      const deltaSeconds = Math.min(0.032, Math.max(0.001, (now - previousTime) / 1000));
      previousTime = now;
      const acceleration = stiffness * (target - position) - damping * velocity;
      velocity += acceleration * deltaSeconds;
      position += velocity * deltaSeconds;
      applyGestureFrame(position, direction);

      const settled = Math.abs(target - position) < 0.45 && Math.abs(velocity) < 4;
      if (settled || now - startedAt > 780) {
        renderSlide(targetIndex);
        startCarousel();
        return;
      }
      settleFrame = window.requestAnimationFrame(spring);
    };

    settleFrame = window.requestAnimationFrame(spring);
  };

  const stopCarousel = () => {
    window.clearInterval(timer);
    timer = null;
  };

  const startCarousel = () => {
    stopCarousel();
    if (slides.length < 2 || isPaused || document.hidden) return;
    timer = window.setInterval(() => renderSlide(activeIndex + 1), 9000);
  };

  const goToSlide = (index) => {
    warmSlideImage(index);
    renderSlide(index);
    startCarousel();
  };

  previous?.addEventListener("click", () => goToSlide(activeIndex - 1));
  next?.addEventListener("click", () => goToSlide(activeIndex + 1));
  dots.forEach((dot) => dot.addEventListener("click", () => goToSlide(Number(dot.dataset.heroDot))));
  toggle?.addEventListener("click", () => {
    isPaused = !isPaused;
    toggle.textContent = isPaused ? "▶" : "Ⅱ";
    toggle.setAttribute("aria-label", isPaused ? "Play slideshow" : "Pause slideshow");
    startCarousel();
  });
  heroCarousel.addEventListener("mouseenter", stopCarousel);
  heroCarousel.addEventListener("mouseleave", startCarousel);
  heroCarousel.addEventListener("focusin", stopCarousel);
  heroCarousel.addEventListener("focusout", startCarousel);
  heroCarousel.addEventListener("pointerdown", (event) => {
    if (slides.length < 2) return;
    if (!event.isPrimary || event.button !== 0) return;
    const acceptsDrag = event.pointerType !== "mouse" || window.matchMedia("(max-width: 820px)").matches;
    if (!acceptsDrag || settleFrame) return;
    gesturePointerId = event.pointerId;
    gestureStartX = event.clientX;
    gestureStartY = event.clientY;
    gestureStartTime = performance.now();
    gestureLastX = event.clientX;
    gestureLastTime = gestureStartTime;
    gestureDeltaX = 0;
    gestureVelocity = 0;
    gestureAxis = "";
    stopCarousel();
  });
  heroCarousel.addEventListener("pointermove", (event) => {
    if (event.pointerId !== gesturePointerId) return;
    const rawDeltaX = event.clientX - gestureStartX;
    const rawDeltaY = event.clientY - gestureStartY;

    if (!gestureAxis) {
      if (Math.hypot(rawDeltaX, rawDeltaY) < 7) return;
      gestureAxis = Math.abs(rawDeltaX) > Math.abs(rawDeltaY) * 1.08 ? "horizontal" : "vertical";
      if (gestureAxis === "vertical") {
        gesturePointerId = null;
        startCarousel();
        return;
      }
      heroCarousel.setPointerCapture?.(event.pointerId);
      heroCarousel.classList.add("is-dragging");
      warmSlideImage(activeIndex - 1);
      warmSlideImage(activeIndex + 1);
    }

    if (gestureAxis !== "horizontal") return;
    event.preventDefault();
    const width = Math.max(1, heroCarousel.clientWidth);
    const softLimit = width * 0.9;
    const magnitude = Math.abs(rawDeltaX);
    gestureDeltaX = Math.sign(rawDeltaX) * (magnitude <= softLimit ? magnitude : softLimit + (magnitude - softLimit) * 0.18);

    const now = performance.now();
    const elapsed = Math.max(1, now - gestureLastTime);
    const instantVelocity = ((event.clientX - gestureLastX) / elapsed) * 1000;
    gestureVelocity = gestureVelocity * 0.68 + instantVelocity * 0.32;
    gestureLastX = event.clientX;
    gestureLastTime = now;
    applyGestureFrame(gestureDeltaX, gestureDeltaX < 0 ? 1 : -1);
  }, { passive: false });
  heroCarousel.addEventListener("pointerup", (event) => {
    if (!event.isPrimary || event.pointerId !== gesturePointerId) return;
    if (gestureAxis !== "horizontal") {
      gesturePointerId = null;
      startCarousel();
      return;
    }
    const elapsed = Math.max(1, performance.now() - gestureStartTime);
    const releaseVelocity = Math.abs(gestureVelocity) > 240 ? gestureVelocity : (gestureDeltaX / elapsed) * 1000;
    const committedByDistance = Math.abs(gestureDeltaX) >= Math.min(92, heroCarousel.clientWidth * 0.2);
    const committedByVelocity = Math.abs(releaseVelocity) > 520;
    const direction = committedByDistance ? (gestureDeltaX < 0 ? 1 : -1) : (releaseVelocity < 0 ? 1 : -1);
    const committedSwipe = committedByDistance || committedByVelocity;
    if (Math.abs(gestureDeltaX) > 9) blockClickUntil = performance.now() + 420;
    settleGesture({ commit: committedSwipe, direction });
  });
  heroCarousel.addEventListener("pointercancel", (event) => {
    if (event.pointerId !== gesturePointerId) return;
    settleGesture({ commit: false, direction: gestureDeltaX < 0 ? 1 : -1, animate: false });
  });
  heroCarousel.addEventListener("click", (event) => {
    if (performance.now() < blockClickUntil) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);
  document.addEventListener("visibilitychange", startCarousel);

  if (reduceMotion && toggle) {
    toggle.textContent = "▶";
    toggle.setAttribute("aria-label", "Play slideshow");
  }
  // The first slide is already fully declared in HTML. Do not rewrite its
  // paint-time styles during hydration; that extra mutation was visible on
  // slower mobile refreshes as a brief flash.
  dots.forEach((dot, dotIndex) => {
    dot.classList.toggle("is-active", dotIndex === 0);
    if (dotIndex === 0) dot.setAttribute("aria-current", "true");
    else dot.removeAttribute("aria-current");
  });
  startCarousel();
  const warmRemainingSlides = () => {
    warmSlideImage(1);
  };
  const scheduleSlideWarmup = () => {
    window.setTimeout(() => {
      if ("requestIdleCallback" in window) window.requestIdleCallback(warmRemainingSlides, { timeout: 3000 });
      else warmRemainingSlides();
    }, 4500);
  };
  if (document.readyState === "complete") scheduleSlideWarmup();
  else window.addEventListener("load", scheduleSlideWarmup, { once: true });
}

const storyFilterButtons = [...document.querySelectorAll("[data-story-filter]")];
const storyFilterLinks = [...document.querySelectorAll("[data-story-filter-link]")];
const storyCards = [...document.querySelectorAll("[data-story-card]")];
const storyGrid = document.querySelector("[data-community-grid]");
const storyFilterStatus = document.querySelector("[data-story-filter-status]");

const applyStoryFilter = (filter) => {
  if (!storyGrid || !storyCards.length) return;

  let visibleCount = 0;
  storyCards.forEach((card) => {
    const categories = (card.dataset.storyCategory || "").split(/\s+/);
    const visible = filter === "all" || categories.includes(filter);
    card.hidden = !visible;
    if (visible) visibleCount += 1;
  });

  storyFilterButtons.forEach((button) => {
    const active = button.dataset.storyFilter === filter;
    button.classList.toggle("is-active", active);
    button.setAttribute("aria-pressed", String(active));
  });

  storyGrid.classList.toggle("is-filtered", filter !== "all");
  storyGrid.classList.toggle("has-single-result", visibleCount === 1);

  if (storyFilterStatus) {
    const label = storyFilterButtons.find((button) => button.dataset.storyFilter === filter)?.textContent.trim() || "selected";
    storyFilterStatus.textContent =
      filter === "all"
        ? "Showing all community preview notes."
        : `Showing ${visibleCount} ${label.toLowerCase()} community preview ${visibleCount === 1 ? "note" : "notes"}.`;
  }
};

storyFilterButtons.forEach((button) => {
  button.addEventListener("click", () => applyStoryFilter(button.dataset.storyFilter || "all"));
});

storyFilterLinks.forEach((link) => {
  link.addEventListener("click", (event) => {
    event.preventDefault();
    applyStoryFilter(link.dataset.storyFilterLink || "all");
    document.querySelector("#field-notes")?.scrollIntoView({ behavior: "smooth", block: "start" });
  });
});

const communityForm = document.querySelector("[data-community-form]");
const communityUpload = document.querySelector("[data-community-upload]");
const communityPreview = document.querySelector("[data-community-preview]");
const communityFormNote = document.querySelector("[data-community-form-note]");
let communityPreviewUrl = null;

communityUpload?.addEventListener("change", () => {
  const file = communityUpload.files?.[0];
  if (!communityPreview) return;

  if (communityPreviewUrl) {
    URL.revokeObjectURL(communityPreviewUrl);
    communityPreviewUrl = null;
  }

  communityPreview.replaceChildren();
  communityPreview.hidden = !file;
  if (!file) return;

  communityPreviewUrl = URL.createObjectURL(file);
  const media = document.createElement(file.type.startsWith("video/") ? "video" : "img");
  media.src = communityPreviewUrl;
  if (media instanceof HTMLVideoElement) {
    media.controls = true;
    media.muted = true;
    media.playsInline = true;
  } else {
    media.alt = "Selected contribution preview";
  }

  const caption = document.createElement("span");
  caption.textContent = `Local preview · ${file.name}`;
  communityPreview.append(media, caption);
});

communityForm?.addEventListener("submit", (event) => {
  event.preventDefault();
  if (!communityForm.checkValidity()) {
    communityForm.reportValidity();
    return;
  }

  const formData = new FormData(communityForm);
  const message = [...formData.entries()]
    .filter(([key, value]) => key !== "file" && String(value).trim())
    .map(([key, value]) => `${key}: ${value}`)
    .join("\n");
  if (communityFormNote) {
    communityFormNote.textContent = "Your email app is opening. Attach the selected photo or video before sending.";
    communityFormNote.classList.add("is-success");
  }
  window.location.href = `mailto:support@roadroam.com?subject=${encodeURIComponent("ROADROAM community contribution")}&body=${encodeURIComponent(message)}`;
});

const systemExperience = document.querySelector("[data-system-experience]");

const painVideoStage = document.querySelector("[data-pain-video]");
const painVideoPlayer = painVideoStage?.querySelector("video.pain-video-player");
const painVideoToggle = painVideoStage?.querySelector("[data-pain-video-toggle]");
const painVideoPlayIcon = painVideoToggle?.querySelector("[data-pain-video-play-icon]");
const painVideoPauseIcon = painVideoToggle?.querySelector("[data-pain-video-pause-icon]");

if (painVideoPlayer && painVideoToggle) {
  const setPainVideoIconState = (icon, hidden) => {
    if (!icon) return;
    icon.toggleAttribute("hidden", hidden);
  };

  const syncPainVideoControl = () => {
    const isPlaying = !painVideoPlayer.paused && !painVideoPlayer.ended;
    setPainVideoIconState(painVideoPlayIcon, isPlaying);
    setPainVideoIconState(painVideoPauseIcon, !isPlaying);
    painVideoStage?.classList.toggle("is-playing", isPlaying);
    painVideoToggle.setAttribute("aria-label", isPlaying ? "Pause video" : "Play video");
  };

  const togglePainVideo = () => {
    if (painVideoPlayer.paused || painVideoPlayer.ended) {
      painVideoPlayer.muted = false;
      painVideoPlayer.play().catch(syncPainVideoControl);
    } else {
      painVideoPlayer.pause();
    }
  };

  painVideoPlayer.addEventListener("play", syncPainVideoControl);
  painVideoPlayer.addEventListener("pause", syncPainVideoControl);
  painVideoPlayer.addEventListener("ended", syncPainVideoControl);
  painVideoToggle.addEventListener("click", togglePainVideo);
  painVideoStage.addEventListener("click", (event) => {
    if (event.target.closest("[data-pain-video-toggle]")) return;
    togglePainVideo();
  });

  syncPainVideoControl();
} else if (painVideoToggle) {
  painVideoToggle.hidden = true;
}

if (systemExperience) {
  const systemTabs = [...systemExperience.querySelectorAll("[data-system-tab]")];
  const systemPanels = [...systemExperience.querySelectorAll("[data-system-panel]")];

  const activateSystem = (key, { moveFocus = false } = {}) => {
    const activeTab = systemTabs.find((tab) => tab.dataset.systemTab === key);
    const activePanel = systemPanels.find((panel) => panel.dataset.systemPanel === key);
    if (!activeTab || !activePanel) return;

    systemTabs.forEach((tab) => {
      const active = tab === activeTab;
      tab.classList.toggle("is-active", active);
      tab.setAttribute("aria-selected", String(active));
      tab.tabIndex = active ? 0 : -1;
    });

    systemPanels.forEach((panel) => {
      const active = panel === activePanel;
      panel.hidden = !active;
      panel.classList.toggle("is-active", active);
    });

    if (moveFocus) activeTab.focus({ preventScroll: true });
    const tabScrollBehavior = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
    activeTab.scrollIntoView({ behavior: tabScrollBehavior, block: "nearest", inline: "center" });
  };

  systemTabs.forEach((tab, index) => {
    tab.addEventListener("click", () => activateSystem(tab.dataset.systemTab || "leveling"));
    tab.addEventListener("keydown", (event) => {
      let nextIndex = index;
      if (event.key === "ArrowRight") nextIndex = (index + 1) % systemTabs.length;
      else if (event.key === "ArrowLeft") nextIndex = (index - 1 + systemTabs.length) % systemTabs.length;
      else if (event.key === "Home") nextIndex = 0;
      else if (event.key === "End") nextIndex = systemTabs.length - 1;
      else return;

      event.preventDefault();
      activateSystem(systemTabs[nextIndex].dataset.systemTab || "leveling", { moveFocus: true });
    });
  });
}

document.querySelectorAll("[data-local-commerce-form]").forEach((form) => {
  const note = form.querySelector("[data-local-commerce-note]");
  form.addEventListener("submit", (event) => event.preventDefault());
  form.querySelectorAll("[data-local-commerce-action]").forEach((button) => {
    button.addEventListener("click", () => {
      if (!note) return;
      note.hidden = false;
      note.focus({ preventScroll: true });
    });
  });
});
